export class ReopenClosedOrderInput {
  orderId: number;
  reason: string;
  newStateId: number;
  userId?: number;
}